import { motion } from "framer-motion";

interface SectionHeadingProps {
  tag?: string;
  title: string;
  description?: string;
  centered?: boolean;
}

export default function SectionHeading({ tag, title, description, centered = true }: SectionHeadingProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`mb-12 ${centered ? "text-center" : ""}`}
    >
      {tag && (
        <span className="mb-3 inline-block rounded-full bg-accent/15 px-4 py-1 font-heading text-xs font-semibold uppercase tracking-widest text-accent">
          {tag}
        </span>
      )}
      <h2 className="font-heading text-3xl font-bold text-foreground md:text-4xl">{title}</h2>
      {description && (
        <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">{description}</p>
      )}
    </motion.div>
  );
}
